import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import ru from 'element-ui/lib/locale/lang/ru-RU'
import en from 'element-ui/lib/locale/lang/en'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const val = matched[1]
      messages[val] = locales(key)
    }
  })
  return messages
}

let i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})

let setComponentLocale = value => {
  switch (value) {
    case 'ru':
      locale.use(ru)
      break
    case 'en':
      locale.use(en)
      break
  }
}
setComponentLocale(i18n.locale)

Object.defineProperty(Vue.prototype, '$locale', {
  get: function () {
    return i18n.locale
  },
  set: function (value) {
    setComponentLocale(value)
    i18n.locale = value
  }
})

export default i18n
